import styled from 'styled-components';

export const StyledDiv = styled.div`
  width: 100%;
`;

export const FooterNotesRenDiv = styled.div`
  padding-left: 16px;
  padding-top: 5px;
  font-style: italic;
  color: #757575;
  font-size: 12px;
  margin-top: -7px;
  background: #ffffff;
`;
